var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Solid/download"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_246_5071",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "master_svg11_0_2300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_246_5071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60001 20.4C3.60001 19.7372 4.13726 19.2 4.80001 19.2H19.2C19.8628 19.2 20.4 19.7372 20.4 20.4C20.4 21.0628 19.8628 21.6 19.2 21.6H4.80001C4.13726 21.6 3.60001 21.0628 3.60001 20.4ZM7.55148 11.1515C8.02011 10.6828 8.7799 10.6828 9.24853 11.1515L10.8 12.7029V3.6C10.8 2.93726 11.3373 2.4 12 2.4C12.6627 2.4 13.2 2.93726 13.2 3.6V12.7029L14.7515 11.1515C15.2201 10.6828 15.9799 10.6828 16.4485 11.1515C16.9171 11.6201 16.9171 12.3799 16.4485 12.8485L12.8485 16.4485C12.6235 16.6735 12.3183 16.8 12 16.8C11.6817 16.8 11.3765 16.6735 11.1515 16.4485L7.55148 12.8485C7.08285 12.3799 7.08285 11.6201 7.55148 11.1515Z",
    fill: "#FFB829"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.98b9bb79e31c85cb4ce568b88ace046f.svg";
export { ForwardRef as ReactComponent };